export const CONTEXT_TYPE_CORPORATE = "corporate"
export const CONTEXT_TYPE_PROVIDER = "provider"
export const CONTEXT_TYPE_EXTERNAL_PARTNER = "partial_partner"
